import { lazy, useEffect } from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLastLocation } from "react-router-last-location";
import { LayoutContextProvider } from "../components/SplashScreen";
import HomePage from "../pages/home/HomePage";
import LogoutPage from "../pages/auth/Logout";
import AuthPage from "../pages/auth/AuthPage";
import * as routerHelpers from "./RouterHelpers";
import { actionTypes } from "../store/ducks/auth.duck";
import TermosDeUso from "../pages/home/configuracoes/termos/TermosDeUsoIndex";
import TermosDeUsoApp from "../pages/home/configuracoes/termos/TermosDeUsoApp";

const AlterarSenhaPage = lazy(() => import("../pages/auth/AlterarSenhaPage"));
const NotFoundPage = lazy(() => import("../pages/error/NotFoundPage"));

export const Routes = withRouter(({ history }) => {
    const lastLocation = useLastLocation();
    const dispatch = useDispatch();

    routerHelpers.saveLastLocation(lastLocation);

    const { isAuthorized, menuConfig, userLastLocation, needChangePassword, forbidden } = useSelector(
        ({ auth }) => ({
            isAuthorized: auth.user != null,
            needChangePassword: auth.user?.ctm_change_password,
            forbidden: auth.forbidden,
            userLastLocation: routerHelpers.getLastLocation(),
        }),
        shallowEqual
    );

    useEffect(() => {
        if (forbidden) {
            dispatch({ type: actionTypes.Forbidden, payload: null });
            history.push("/404");
        }
    }, [forbidden]);

    return (
        <LayoutContextProvider history={history} menuConfig={menuConfig}>
            <Switch>
                <Route path="/404" component={NotFoundPage} />
                <Route exact path="/logout" component={LogoutPage} />
                <Route exact path="/termos-de-uso" component={TermosDeUso} />
                <Route exact path="/termos-de-uso/app" component={TermosDeUsoApp} />

                {needChangePassword ? (
                    <>
                        <Route exact path="/alterar-senha" component={AlterarSenhaPage} />
                        <Redirect to="/alterar-senha" />
                    </>
                ) : !isAuthorized ? (
                    <Route component={AuthPage} />
                ) : (
                    <HomePage userLastLocation={userLastLocation} />
                )}
            </Switch>
        </LayoutContextProvider>
    );
});
